import { LawType, SearchableLawTextInstantSearch } from '@livv/models';
import { completePreviewLink, getLawLink, getSheetLink } from '@livv/utils/helpers';
import { FC } from 'react';
import ContentCard, { PreviewCardProps } from './ContentCard';
import { APP_URL } from '@utils/consts/livv';
import { useFreemiumDialog } from '@utils/context/freemiumDialog';
import { getFullTextSearchQuery } from '@utils/search/snippet';

interface LawTextPreviewProps extends PreviewCardProps<SearchableLawTextInstantSearch> {
    query: string;
}

const LawTextPreview: FC<LawTextPreviewProps> = ({ hit, query }) => {
    const { openFreemiumDialog } = useFreemiumDialog();

    const { baseObjectID, path, treeId } = hit;
    const isCodeArticle = baseObjectID.startsWith(LawType.LEGIARTI);
    const baseHref = isCodeArticle
        ? getSheetLink({ bookId: treeId, bookPath: path.join('/'), sheetId: baseObjectID })
        : getLawLink(baseObjectID);

    return (
        <ContentCard
            hit={hit}
            href={completePreviewLink(baseHref, APP_URL, getFullTextSearchQuery(hit, query))}
            onClick={isCodeArticle ? undefined : openFreemiumDialog}
            snippetAttribute="fullText"
            subtitleAttributes={[{ attribute: 'subtitle' }]}
            titleAttribute="title"
        />
    );
};

export default LawTextPreview;
